<template>
  <div
    class="show-answer"
    :style="getMargin"
    style="display: flex; flex-direction: row; justify-content: left"
  >
    <template v-for="answer in sortedAnswers">
      <div style="display: flex; flex-direction: column">
        <span class="fa fa-stack">
          <span
            :title="getTitle(answer)"
            :class="getIconClass(answer.answer)"
            class="fa-stack-1x"
            style="margin-right:5px;"
          />
          <span class="fa fa-stack-1x fa-star-o" />
        </span>
        <span
          class="scale-text pt-1"
          style="text-align: center"
        >
          {{ answer.answer }}
        </span>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'TenScaleQuestionResult',
  props: {
    answers: { required: true },
    hasMargin: { default: true },
  },
  computed: {

    sortedAnswers () {
      function compare (a, b) {
        if (parseInt(a.answer) < parseInt(b.answer)) { return -1 }
        if (parseInt(a.answer) > parseInt(b.answer)) { return 1 }
        return 0
      }

      return [...this.answers].sort(compare)
    },

    average () {
      let count = 0.5
      this.answers.forEach(function (answer) {
        count = count + answer.answer * answer.percentage_numeric
      })
      return count / 100
    },

    getMargin () {
      if (this.hasMargin == true) {
        return ''
      } else {
        return 'margin-left:20px'
      }
    },
  },
  methods: {
    getIconClass (answer) {
      if (this.average >= parseFloat(answer, 10)) {
        return 'fa fa-star'
      } else if (this.average >= parseFloat(answer, 10) - 0.5) {
        return 'fa fa-star half-star'
      } else {
        return 'fa fa-star-o'
      }
    },

    getTitle (answer) {
      return Lang.get('review.answer_option.ten_scale.' + answer.answer) + ' <br /> ' + answer.percentage
    },
  },
}
</script>

<style scoped>
    .half-star {
        clip-path: polygon(50% 0%, 50% 100%, 0% 100%, 0% 0%);
    }

    .answer {
        margin-right: 10px;
    }

    .show-answer {
        display: inline-block;
    }

</style>
